import store from '@/store'  
export default async (to, from, next) => { 
  const restaurant = store.getters["restaurant/restaurant"] 
  if ( restaurant.payment_type == null) {
    next({ name: 'restaurants' });
  } else {
    next();
  } 
}
